<template>
  <object-details-template offer-object>
    <template #header>
      <object-offer-header
        v-if="currentOffer"
        :content="object"
        :offer="currentOffer"
      />
    </template>
  </object-details-template>
</template>

<script>
import {
  fetchObjectData,
  fetchOfferData,
} from '@/views/Brand/Objects/mixins/fetchObjectData';
import VueStore from '@/store';
import { mapState } from 'vuex';
import ObjectOfferHeader from '@/views/Brand/Objects/_components/Offer/ObjectOfferHeader';
import ObjectDetailsTemplate from '@/views/Brand/Objects/Components/ObjectDetailsTemplate';

export default {
  components: {
    ObjectDetailsTemplate,
    ObjectOfferHeader,
  },
  computed: {
    ...mapState('offer', ['currentOffer']),
    ...mapState('object', { object: 'details' }),
  },
  async beforeRouteEnter(to, from, next) {
    await fetchOfferData(to);
    await fetchObjectData(to, true);

    next();
  },
  async beforeRouteUpdate(to, from, next) {
    await fetchOfferData(to);
    await fetchObjectData(to, true);

    next();
  },
  async beforeRouteLeave(to, from, next) {
    if (to.meta.matchName !== 'Offers') {
      await VueStore.dispatch('offer/clearState');
    }

    next();
  },
};
</script>
